module.exports = __webpack_public_path__ + "static/media/tree-step-4_3.c25dc5c2.svg";